import { React, useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import SkeletonWithLoaders from 'components/common/Spinner';
import { setassigneelist } from 'store/actions';
import { setTaskstatuslist } from 'store/actions';
import SubtaskObject from '@atlaskit/object/subtask';
import LogWork from './LogWork';
import LinkWorkItemInput from './LinkWorkItemInput';
import ListLinkedWorkItems from './ListLinkedWorkItems';
import {
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  Tab,
} from '@chakra-ui/react';
import { FaLock, FaEye, FaShareAlt } from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import WebLink from './WebLink';
import WebLinkList from './ListWebLinks';

import { AddIcon, ChevronDownIcon } from '@chakra-ui/icons';

import Cookies from 'js-cookie';
import { Card } from 'antd';
import { useSelector } from 'react-redux';
import SubtaskmodalActivity from './SubtaskmodalActivity';

const Newtabsubtaskdetails = ({ isOpen, onClose, subtaskdetails }) => {
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const { projectId, subtaskId } = useParams();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [subtaskdata, setsubTaskData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [commentInput, setCommentInput] = useState('');
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [editableTasks, setEditableTasks] = useState({});
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [workItems, setWorkItems] = useState(null);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);

  const [taskList, settaskList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState(
    subtaskdata?.subtask_title || '',
  );
  const [visibleReplies, setVisibleReplies] = useState({});
  const [selectedparent, setSelectedParent] = useState(null);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [assigneeList, setassigneeList] = useState([]);
  const [statusList, setstatusList] = useState([]);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const dispatch = useDispatch();
  const innerResizingRef = useRef(false);
  const startInnerXRef = useRef(0);
  const MIN_WIDTH = 250;
  const getMaxWidth = () =>
    Math.min(window.innerWidth * 0.5, window.innerWidth - 250);
  // 50% of screen or leave 250px for left panel

  const [rightWidth, setRightWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  const resizingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const onMouseDown = (e) => {
    resizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = rightWidth;
    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!resizingRef.current) return;
    const dx = e.clientX - startXRef.current;

    let newW = startWidthRef.current - dx; // drag right -> shrink
    const MAX_WIDTH = getMaxWidth();
    newW = Math.min(Math.max(newW, MIN_WIDTH), MAX_WIDTH);
    setRightWidth(newW);
  };

  const onMouseUp = () => {
    resizingRef.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev);
  };

  // Update rightWidth dynamically on window resize
  useEffect(() => {
    const handleResize = () => {
      setRightWidth((prev) => Math.min(prev, window.innerWidth * 0.5));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const innerResizingRef = useRef(false);
  //   const startInnerXRef = useRef(0);
  const startRightWidthRef = useRef(0);

  const onMouseDownInner = (e) => {
    innerResizingRef.current = true;
    startInnerXRef.current = e.clientX;
    startRightWidthRef.current = rightWidth;
    document.addEventListener('mousemove', onMouseMoveInner);
    document.addEventListener('mouseup', onMouseUpInner);
  };

  const onMouseMoveInner = (e) => {
    if (!innerResizingRef.current) return;
    const dx = e.clientX - startInnerXRef.current;

    // ✅ Flip direction: drag right → shrink right box
    const newWidth = Math.min(
      Math.max(startRightWidthRef.current - dx, 250),
      700,
    );
    setRightWidth(newWidth);
  };

  const onMouseUpInner = () => {
    innerResizingRef.current = false;
    document.removeEventListener('mousemove', onMouseMoveInner);
    document.removeEventListener('mouseup', onMouseUpInner);
  };
  // stores comment_id of open reply editor
  const [storyPoints, setStoryPoints] = useState('');

  const roleId = Number(Cookies.get('task-role-id'));

  const handleSaveTitle = () => {
    if (editedTitle.trim() === '') return;
    // --- call your API/update function here ---
    handleTaskUpdate('issue_title', editedTitle);
    setIsEditingTitle(false);
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response =
        await httpInjectorService.getProjectAssignedEmployeelist(projectId);
      if (response.status === 'success') {
        setassigneeList(response.data);

        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
        setassigneeList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const listBoardStatus = async () => {
    let project_id = projectId;
    try {
      const response = await httpInjectorService.ListBoardStatus(project_id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        setstatusList(statusList);
        dispatch(setTaskstatuslist(statusList));
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        setstatusList(statusList);

        // set({});
      }
    } catch (error) {
      throw error;
    }
  };

  const handleCancel = () => {
    // setEditedTitle(taskdata?.task_title || "");
    setIsEditingTitle(false);
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(subtaskdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(subtaskdata.start_date),
  );

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        project_id: subtaskdata.project_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deletetaskcomment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Something went wrong while deleting comment');
    }
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: subtaskdata.project_id,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.edit_comment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

  const handleSaveLink = (data) => {
   
    setRefreshLinks((prev) => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

  useEffect(() => {
    if (subtaskdata?.labels) {
      const formatted = subtaskdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [subtaskdata]);

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        subtask_id: subtaskId,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      requestBody.labels_id = existingLabelIds; // even if empty []

      const response =
        await httpInjectorService.updateSubtaskLabels(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const getsubtaskdata = async () => {
    const queryParams = `?subtask_id=${Number(subtaskId)}&project_id=${Number(
      projectId,
    )}`;
    try {
      const response = await httpInjectorService.getSubtaskById(queryParams);
      if (response.status === 'success') {
        setsubTaskData(response?.data);
      } else {
        setsubTaskData({});
      }
    } catch (error) {
      throw error;
    }
  };

  const getLinkedWorkItems = async () => {
    let reqbody = {
      item_type: 'subtask',
      item_id: subtaskdetails?.subtask_id,
    };
    try {
      let response = await httpInjectorService.getLinkedWorkItems(reqbody);
      if (response.status === 'success') {
        setWorkItems(response.data);
      } else {
        setWorkItems({});
      }
    } catch (e) {
      throw e;
    }
  };

  const IssueIcon = ({ type }) => {
    const style = { flexShrink: 0 };

    switch (type) {
      case 'TASK':
        return <TaskObject size="medium" style={style} />;

      case 'STORY':
        return <StoryObject size="medium" style={style} />;

      case 'BUG':
        return <BugObject size="medium" style={style} />;

      default:
        return <TaskObject size="medium" style={style} />;
    }
  };

  useEffect(() => {
    if (projectId && subtaskId) {
      getsubtaskdata();
      getprojectAssignedEmployee();
      listBoardStatus();
    }
  }, [projectId, subtaskId]);

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const handleMentionSelect = (user) => {
    const words = commentInput.trim().split(/\s+/);
    words.pop(); // remove @something
    words.push(`@${user.username}`);
    const newText = words.join(' ') + ' ';
    setCommentInput(newText);
    setTaggedUsers((prev) => [...prev, user]); // Store tagged user info
    setMentionSuggestions([]);
    setMentionQuery('');
  };

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = subtaskdata?.sprint_name || ' ';
        const matchedSprint = options.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (isOpen) {
      //   getsubtaskdata();
    }
    getsprintlist();
    getLabelList();
    gettasklist();
    getLinkedWorkItems();
  }, [isOpen]);

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  useEffect(() => {
    if (subtaskdata) {
      setDescription(subtaskdata?.description);
      setDueDate(formatDateInput(subtaskdata?.due_date) || '');
      setStartDate(formatDateInput(subtaskdata?.start_date) || '');
      setStoryPoints(subtaskdata?.story_points ?? '');
      if (subtaskdata?.issue_id && subtaskdata?.issue_title) {
        setSelectedParent({
          value: subtaskdata.issue_id,
          label: subtaskdata.issue_title,
        });
      } else {
        setSelectedParent(null);
      }
    }
  }, [isOpen, subtaskdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleTaskUpdate = async (emp = {}) => {
    const finalBody = {
      issue_id: emp.value ? emp.value : subtaskdetails?.issue_id,
      subtask_id: subtaskId,
      project_id: projectId,
      title: editedTitle || subtaskdata?.subtask_title,
      // parenttask_id: selectedEpic || selectedparent?.value || subtaskdata.epic_id,
      sprint_id: emp?.value || subtaskdata.sprint_id || null,
      // parent: selectedparent?.value || subtaskdata.task_id || null,
      story_points: Number(storyPoints) || subtaskdata.story_points || null,
      subtask_assignee_id: emp?.user_id || subtaskdata.assignee_id || null,
      description: description?.trim() || subtaskdata.description || '',
      subtask_status: emp?.status_name || subtaskdata?.status,
      subtask_priority: subtaskdata.priority,
      start_date:
        startDate ||
        (subtaskdata?.start_date
          ? formatDateInput(subtaskdata.due_date)
          : null),
      due_date:
        dueDate ||
        (subtaskdata?.due_date ? formatDateInput(subtaskdata.due_date) : null),
    };

    try {
      const response = await httpInjectorService.updatesubtaskdata(finalBody);
      if (response?.status === 'success') {
        getsubtaskdata();
        // getTaskBoardDetails();
      }
    } catch (error) {
      toast.error('Something went wrong.');
    }
  };
  const debouncedUpdate = useCallback(
    debounce(() => handleTaskUpdate(), 400),
    [handleTaskUpdate],
  );

  const handleCommentChange = (value) => {
    setCommentInput(value);

    // Find the last "@mention" pattern anywhere in the text
    const match = value.match(/@(\w*)$/);

    if (match) {
      const query = match[1].toLowerCase();
      const suggestions = assigneeList.filter((user) =>
        user.username.toLowerCase().includes(query),
      );
      setMentionQuery(query);
      setMentionSuggestions(suggestions);
    } else {
      setMentionQuery('');
      setMentionSuggestions([]);
    }
  };

  const justOpenedRef = useRef(true);

  const gettasklist = async () => {
    try {
      const response = await httpInjectorService.gettimelinetask(
        `?project_id=${projectId}`,
      );
      settaskList(response.data);
    } catch (error) {
      throw error;
    }
  };

  // useEffect(() => {
  //   if (epicModalOpen) {
  //     getEpiclist(); // fetch only when modal is opened
  //   }
  // }, [epicModalOpen]);

  const isEditable = [1, 2, 3].includes(roleId);

  // const handleAddSubtask = async () => {
  //   let reqbody = {
  //     project_id: taskdata.project_id,
  //     task_id: taskdata.task_id,
  //     title: childTaskTitle || '',
  //     description: null,
  //     subtask_status: 'TO DO',
  //     subtask_priority: 'Medium',
  //     start_date: null,
  //     due_date: null,
  //     labels_id: null,
  //     subtask_assignee_id: null,
  //   };

  //   try {
  //     const response = await httpInjectorService.addSubtask(reqbody);
  //     if (response.status === 'success') {
  //       setChildTaskTitle('');
  //       setShowChildInput(false);
  //       setReloadSubtasks((prev) => prev + 1);
  //       // getsubtaskList(); // Refresh list
  //     } else {
  //       console.error('Failed to add subtask');
  //     }
  //   } catch (error) {
  //     console.error('Error adding subtask:', error);
  //   }
  // };

  const handlesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  useEffect(() => {
    if (isOpen) {
      setLoading(true);

      const fetchAllData = async () => {
        try {
          await Promise.all([
            getsubtaskdata(),
            getsprintlist(),
            // getLabelList(),
            // getsubtaskList(),
          ]);
        } catch (error) {
          throw error;
        } finally {
          setLoading(false);
        }
      };

      fetchAllData();
    }
  }, []);

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const currentStatus = newstatus || subtaskdata?.status;
  const { bg, color } = getStatusColors(currentStatus);

  return (
    <Card
      style={{
        position: 'fixed',
        top: '60px',
        left: '80px',
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div>
        <Flex
          align="center"
          justify="space-between"
          px={6}
          py={3}
          borderBottom="1px solid #e2e8f0"
          flex="0 0 64px" // fixed header height
          minHeight="64px"
          zIndex="4"
          bg="white"
        >
          <HStack spacing={0} align="center">
            <HStack spacing={1} align="center">
              <Flex align="baseline" gap={0}>
                <IssueIcon type={subtaskdata?.issue_name} />

                <Text fontSize="md" color="gray.600">
                  {subtaskdata?.issue_key}
                </Text>
              </Flex>
            </HStack>

            <Text fontSize="md" color="gray.600" mx={1}>
              /
            </Text>

            <Text fontSize="md" color="gray.500">
              <SubtaskObject
                size={20}
                stroke="#0052CC"
                fill="white"
                strokeWidth={2}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  lineHeight: 1,
                }}
              />
              {subtaskdata?.subtask_key}
            </Text>
          </HStack>

          <HStack spacing={2}>
            <IconButton
              icon={<FaLock />}
              size="sm"
              variant="ghost"
              aria-label="lock"
            />
            <LogWork
              work_Id={subtaskdata?.subtask_id}
              work_Type="SUBTASK"
              taskDetails={subtaskdata}
              onSaved={handleLogSaved}
            />
            <IconButton
              icon={<FaEye />}
              size="sm"
              variant="ghost"
              aria-label="view"
            />
            <IconButton
              icon={<FaShareAlt />}
              size="sm"
              variant="ghost"
              aria-label="share"
            />
            <Flex align="center" gap={4}>
              {/* Open in new tab icon */}
              {/* <Box
                    as="button"
                    onClick={() => {
                      const url = `/admin/taskBoard/${subtaskdetails?.project_id}/taskDetails/${subtaskdata?.task_id}`;
                      window.open(url, '_blank');
                    }}
                    cursor="pointer"
                    _hover={{ color: 'blue.500' }}
                    bg="transparent"
                    border="none"
                  >
                    <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
                  </Box> */}
            </Flex>
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="sm"
              variant="ghost"
              aria-label="action"
            />
          </HStack>
        </Flex>

        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="row"
          bg="white"
          overflowY="auto"
        >
          {loading ? (
            <Flex justify="center" align="center" w="100%" h="300px">
              <SkeletonWithLoaders />
            </Flex>
          ) : (
            <Flex width="100%">
              <Box
                flex="1"
                p={6}
                overflowY="auto"
                bg="white"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Box mb={4}>
                  {!isEditingTitle ? (
                    // --- Normal Text ---
                    <Text
                      fontSize="2xl"
                      fontWeight="bold"
                      cursor="pointer"
                      onClick={() => {
                        if ([1, 2, 3].includes(roleId)) {
                          setEditedTitle(subtaskdata?.subtask_title);
                          setIsEditingTitle(true);
                        }
                      }}
                    >
                      {editedTitle ||
                        subtaskdata?.subtask_title ||
                        'Task Title'}
                    </Text>
                  ) : (
                    // --- Editing Mode ---
                    <Box position="relative" width="100%">
                      <Input
                        value={editedTitle}
                        onChange={(e) => setEditedTitle(e.target.value)}
                        size="lg"
                        fontSize="2xl"
                        fontWeight="bold"
                        autoFocus
                        height="40px"
                        focusBorderColor="gray.300"
                        borderRadius="md"
                      />

                      {/* Wrapper ABSOLUTE but not blocking input */}
                      <HStack
                        spacing={2}
                        position="absolute"
                        right="0"
                        top="100%"
                        mt={1}
                        pointerEvents="none"
                      >
                        <Box
                          p={1}
                          border="1px solid #d1d5db"
                          borderRadius="sm"
                          cursor="pointer"
                          pointerEvents="auto"
                          onClick={() => {
                            handleTaskUpdate(); // call the update function
                            setIsEditingTitle(false); // exit edit mode
                          }}
                        >
                          <CheckIcon boxSize={4} color="grey" />
                        </Box>

                        <Box
                          p={1}
                          border="1px solid #d1d5db"
                          borderRadius="sm"
                          cursor="pointer"
                          pointerEvents="auto"
                          onClick={handleCancel}
                        >
                          <CloseIcon boxSize={4} color="grey" />
                        </Box>
                      </HStack>
                    </Box>
                  )}

                  {[1, 2, 3].includes(roleId) && (
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<AddIcon />}
                        size="sm"
                        aria-label="Add actions"
                        bg="#f3f4f6"
                        border="1px solid #d1d5db"
                        borderRadius="md"
                        _hover={{ bg: '#e5e7eb' }}
                        _active={{ bg: '#e5e7eb' }}
                        color="gray.700"
                        mt={1}
                        mb={30}
                      />

                      <MenuList zIndex={2}>
                        {/* <MenuItem onClick={() => setShowChildInput(true)}>
                            Create child work item
                          </MenuItem> */}
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Add connected work
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Add Attachment
                        </MenuItem>
                        <MenuItem onClick={handleOpenLinkWorkItem}>
                          Link work Items
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                                    console.log('clicked');
                                    setShowWebLink(true);
                                  }}
                        >
                           Add web link
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Whiteboard
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
                </Box>

                <Box mb={6} mt={2}>
                  <Text fontWeight="semibold" mb={2}>
                    Description
                  </Text>

                  {!isEditingDescription ? (
                    <Box
                      p={3}
                      border="1px solid #e2e8f0"
                      // borderRadius="8px"
                      minH="60px"
                      bg="white"
                      onClick={() =>
                        [1, 2, 3].includes(roleId) &&
                        setIsEditingDescription(true)
                      }
                      cursor={
                        ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                      }
                    >
                      {description ? (
                        <Box
                          dangerouslySetInnerHTML={{ __html: description }}
                          fontSize="sm"
                        />
                      ) : (
                        <Text color="gray.400" fontSize="sm">
                          Add a description...
                        </Text>
                      )}
                    </Box>
                  ) : (
                    <Box>
                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={setDescription}
                        placeholder="Write a description..."
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ color: [] }, { background: [] }],
                            ['link', 'image', 'code-block'],
                            ['clean'],
                          ],
                        }}
                        style={{
                          backgroundColor: 'white',
                          // borderRadius: '8px',
                          minHeight: '140px',
                        }}
                      />
                      <Flex justify="flex-start" mt={1} gap={2}>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          borderRadius="0px"
                          onClick={() => {
                            setIsEditingDescription(false);
                            handleTaskUpdate('description', description); // ✅ Save on Done click
                          }}
                        >
                          Save
                        </Button>
                        <Button
                          size="sm"
                          variant="ghost"
                          borderRadius="0px"
                          onClick={() => setIsEditingDescription(false)}
                        >
                          cancel
                        </Button>
                      </Flex>
                    </Box>
                  )}
                </Box>

                {/* Comment Input */}
                {workItems.length > 0 && (
                  <Tab
                    fontSize="12px"
                    px="8px"
                    py="3px"
                    _selected={{
                      border: '1px solid #3182CE',
                      color: '#3182CE',
                      bg: 'white',
                      borderRadius: '4px',
                    }}
                  >
                    Linked Items
                  </Tab>
                )}

                {workItems.length > 0 && (
                  <ListLinkedWorkItems
                    item_id={subtaskdetails?.subtask_id}
                    item_type={'subtask'}
                    refreshFlag={refreshLinkedItems}
                  />
                )}
                {openLinkWorkItem && (
                  <div style={{ marginTop: '16px' }}>
                    <LinkWorkItemInput
                      onCancel={() => setOpenLinkWorkItem(false)}
                      current_item_type={'subtask'}
                      current_item_id={subtaskdata.subtask_id}
                    />
                  </div>
                )}

                {showWebLink && (
                  <WebLink
                    onClose={() => setShowWebLink(false)}
                    onSave={handleSaveLink}
                    work_id={subtaskdata.subtask_id}
                    work_type={'subtask'}
                  />
                )}
                <WebLinkList
                  work_id={subtaskdata.subtask_id}
                  work_type={'subtask'}
                  refreshFlag={refreshLinks}
                />

                <Box>
                  <SubtaskmodalActivity
                    subtaskDetails={subtaskdetails}
                    subtaskdata={subtaskdata}
                    subtaskID={subtaskdata.subtask_id}
                    projectId={subtaskdata.project_id}
                    refreshKey={refreshKey}
                  />
                </Box>
              </Box>

              <Box
                width="6px"
                cursor="ew-resize"
                bg="gray.200"
                _hover={{ bg: 'gray.400' }}
                onMouseDown={onMouseDown}
              />
              <Box
                flex="none"
                width={`${rightWidth}px`}
                p={6}
                pr={0}
                right={0}
                borderLeft="1px solid #e2e8f0"
                // bg="gray.50"
                overflowY="auto"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  // display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Tooltip
                  label={!isEditable ? 'You do not have permission' : ''}
                >
                  <Menu isDisabled={!isEditable}>
                    <MenuButton
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                      size="sm"
                      mb={4}
                      p={0}
                      px={0}
                      minW="fit-content"
                      width="fit-content"
                      height="auto"
                      borderRadius="md"
                      bg={bg} // status background
                      color={color} // text color
                      border="1px solid #ccc"
                      _hover={{ bg }}
                      _active={{ bg }}
                    >
                      <Badge
                        bg="transparent"
                        color={color}
                        fontSize="0.8em"
                        p={1}
                      >
                        {currentStatus}
                      </Badge>
                    </MenuButton>

                    {isEditable && (
                      <MenuList>
                        {statusList.map((status) => {
                          const { bg, color } = getStatusColors(
                            status.status_name,
                          );
                          return (
                            <MenuItem
                              key={status.id}
                              onClick={() => {
                                handleStatusChange(status.status_name);
                                handleTaskUpdate(status);
                              }}
                            >
                              <Badge
                                bg={bg}
                                color={color}
                                fontSize="0.75em"
                                p={1}
                                borderRadius="md"
                              >
                                {status.status_name}
                              </Badge>
                            </MenuItem>
                          );
                        })}
                      </MenuList>
                    )}
                  </Menu>
                </Tooltip>

                <Grid
                  templateColumns="120px 1fr"
                  rowGap={5}
                  columnGap={6}
                  alignItems="start"
                >
                  <Text fontWeight="semibold">Assignee</Text>
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Popover
                      isOpen={showEmployeePicker}
                      onClose={() => setShowEmployeePicker(false)}
                    >
                      <Box position="relative" width="fit-content">
                        <PopoverTrigger>
                          <HStack
                            spacing={2}
                            onClick={() =>
                              setShowEmployeePicker(!showEmployeePicker)
                            }
                            cursor="pointer"
                          >
                            {selectedEmployee?.username ||
                            subtaskdata?.assignee_name ? (
                              <>
                                <UserAvatar
                                  username={
                                    selectedEmployee?.username ||
                                    subtaskdata?.assignee_name
                                  }
                                  size={24}
                                />
                                <Text fontSize="sm">
                                  {selectedEmployee?.username ||
                                    subtaskdata?.assignee_name}
                                </Text>
                              </>
                            ) : (
                              <HStack spacing={1} color="gray.500">
                                <MdOutlinePerson size={20} />
                                <Text fontSize="sm">Unassigned</Text>
                              </HStack>
                            )}
                          </HStack>
                        </PopoverTrigger>
                      </Box>
                      {isEditable && (
                        <PopoverContent width="auto">
                          <PopoverBody>
                            {assigneeList?.length > 0 ? (
                              <Box maxH="200px" overflowY="auto">
                                {assigneeList.map((emp) => (
                                  <Box
                                    key={emp.user_id}
                                    onClick={() => {
                                      setSelectedEmployee(emp);
                                      setShowEmployeePicker(false);
                                      handleTaskUpdate(emp);
                                    }}
                                    display="flex"
                                    alignItems="center"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    cursor="pointer"
                                    bg={
                                      selectedEmployee?.user_id === emp.user_id
                                        ? '#e6f4ff'
                                        : 'transparent'
                                    }
                                    _hover={{ bg: '#f1f5f9' }}
                                  >
                                    <UserAvatar
                                      username={emp.username}
                                      size={24}
                                      style={{ marginRight: '8px' }}
                                    />
                                    <Text fontSize="sm">{emp.username}</Text>
                                  </Box>
                                ))}
                              </Box>
                            ) : (
                              <Text fontSize="sm" color="gray.500">
                                No employees found
                              </Text>
                            )}
                          </PopoverBody>
                        </PopoverContent>
                      )}
                    </Popover>
                  </Tooltip>

                  <Text fontWeight="semibold">Labels</Text>
                  {/* <Box w="100%">
                        <CreatableSelect
                          placeholder="Select or create label"
                          isClearable
                          isMulti
                          value={selectedLabel}
                          options={labellist.map((label) => ({
                            label: label.label_name,
                            value: label.label_id,
                          }))}
                          onChange={(newValue) => setSelectedLabel(newValue || [])}
                          formatCreateLabel={(inputValue) =>
                            `Create new label: "${inputValue}"`
                          }
                        />
                      </Box> */}
                  <Box w="100%">
                    {/* <CreatableSelect
                                        placeholder="Select or create label"
                                        isClearable
                                        isMulti
                                        value={
                              selectedLabel.length > 0
                                ? selectedLabel
                                : (taskdata?.labels || []).map((label) => ({
                                    label: label.label_name || label,
                                    value: label.label_id || label,
                                  }))
                            }
                                        options={labellist.map((label) => ({
                                          label: label.label_name,
                                          value: label.label_id,
                                          __isNew__: false,
                                        }))}
                                        onChange={(newValue) => {
                                          setSelectedLabel(newValue || []);
                                        }}
                                        formatCreateLabel={(inputValue) =>
                                          `Create new label: "${inputValue}"`
                                        }
                                      /> */}
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      isClearable
                      isMulti
                      placeholder="Select or create label"
                      value={selectedLabel} // ✔ ONLY this
                      options={labellist?.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                        __isNew__: false,
                      }))}
                      onChange={(newValue) => {
                        const updated = newValue || [];

                        setSelectedLabel(updated);
                        handleAddLabel(updated); // ← Pass updated list
                      }}
                    />
                  </Box>

                  <Text fontWeight="semibold">Parent</Text>
                  <CreatableSelect
                    isDisabled={![1, 2, 3].includes(roleId)}
                    placeholder="Select Parent"
                    isClearable
                    value={selectedparent}
                    onChange={(selected) => {
                      setSelectedParent(selected);
                      handleTaskUpdate(selected);
                    }}
                    options={taskList?.map((task) => ({
                      value: task.issue_id,
                      label: `${task.issue_key} - ${task.issue_title}`,
                    }))}
                  />

                  <Text fontWeight="semibold">Due date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    onBlur={handleTaskUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate(); // ✅ Save on Enter
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Start date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    onBlur={handleTaskUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Sprint</Text>
                  <Text>
                    {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select or create sprint"
                      isClearable
                      value={
                        selectedSprint ||
                        sprintOptions.find(
                          (s) => s.label === subtaskdata?.sprint_name,
                        ) ||
                        (subtaskdata?.sprint_name
                          ? {
                              label: subtaskdata.sprint_name,
                              value: subtaskdata.sprint_id,
                            }
                          : null)
                      }
                      options={sprintOptions}
                      onChange={(newValue) => {
                        setSelectedSprint(newValue);
                        handleTaskUpdate(newValue);
                      }}
                      formatCreateLabel={(inputValue) =>
                        `Create new sprint: "${inputValue}"`
                      }
                    />
                  </Text>

                  <Text fontWeight="semibold">Story points</Text>
                  <Input
                    size="sm"
                    placeholder="Add story points"
                    w="100%"
                    type="number"
                    value={storyPoints}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Keep only digits (0–9)
                      const onlyInt = value.replace(/[^\d]/g, '');

                      setStoryPoints(onlyInt);
                    }} // <-- update state
                    onBlur={debouncedUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Development</Text>
                  <VStack align="start" spacing={2}></VStack>

                  <Text fontWeight="semibold">Reporter</Text>
                  <HStack align="center" spacing={2}>
                    <Avatar
                      name={subtaskdata?.subtask_creator_name || 'Unknown'}
                      size="xs"
                    />
                    <Text fontSize="sm" lineHeight="1">
                      {subtaskdata?.subtask_creator_name || 'Unknown'}
                    </Text>
                  </HStack>
                </Grid>

                <div
                  style={{
                    marginTop: 0,
                    padding: '12px 16px',
                    // border: '1px solid #e6e6e6',
                    borderRadius: 8,
                    // background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                  }}
                >
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Created at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {subtaskdata?.created_at
                        ? dayjs(subtaskdata?.created_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Updated at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {subtaskdata?.updated_at
                        ? dayjs(subtaskdata?.updated_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                </div>
              </Box>
            </Flex>
          )}
        </Box>
      </div>
    </Card>
  );
};

export default Newtabsubtaskdetails;
